import React from 'react';
import ActivityPage from '@/pageComponents/Activity';

const Activity = () => <ActivityPage pathname="/activity" />;

export default Activity;
